"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function dateStringFromValue(value) {
    if (typeof value === 'number' || typeof value === 'string') {
        return new Date(value).toISOString();
    }
    else if (value instanceof Date) {
        return value.toISOString();
    }
    else {
        return value;
    }
}
exports.dateStringFromValue = dateStringFromValue;
exports.expression = {
    // Constructors
    // ============
    newBool(value) {
        return { newBool: value };
    },
    newDateTime(value) {
        return { newDateTime: dateStringFromValue(value) };
    },
    newString(value) {
        return { newString: value };
    },
    newSymbol(value) {
        return { newSymbol: value };
    },
    newInt(value) {
        return { newInt: value };
    },
    newInt8(value) {
        return { newInt8: value };
    },
    newInt16(value) {
        return { newInt16: value };
    },
    newInt32(value) {
        return { newInt32: value };
    },
    newInt64(value) {
        return { newInt64: value };
    },
    newUint(value) {
        return { newUint: value };
    },
    newUint8(value) {
        return { newUint8: value };
    },
    newUint16(value) {
        return { newUint16: value };
    },
    newUint32(value) {
        return { newUint32: value };
    },
    newUint64(value) {
        return { newUint64: value };
    },
    newFloat(value) {
        return { newFloat: value };
    },
    newMap(value) {
        return { newMap: value };
    },
    newList(...value) {
        return { newList: value };
    },
    newStruct(value = {}) {
        return { newStruct: value };
    },
    newTuple(...value) {
        return { newTuple: value };
    },
    newUnion(caseKey, value) {
        return { newUnion: { case: caseKey, value } };
    },
    newRef(modelID, recordID) {
        return { newRef: { model: modelID, id: recordID } };
    },
    // Expression Scope
    // ================
    // Other
    // -----
    model(id) {
        return { model: id };
    },
    modelOf(expr) {
        return { modelOf: expr };
    },
    metarialize(record) {
        return { metarialize: record };
    },
    zero() {
        return { zero: {} };
    },
    switchType(value, map) {
        return { switchType: Object.assign({}, map, { value }) };
    },
    // Scope
    // -----
    bind(value) {
        return { bind: value };
    },
    arg() {
        return { arg: {} };
    },
    id() {
        return { id: {} };
    },
    contextual(value) {
        return { contextual: value };
    },
    static(value) {
        return { static: value };
    },
    do(expressions) {
        return { do: expressions };
    },
    with(value, returnValue) {
        return { with: { value, return: returnValue } };
    },
    // Date Time
    // ---------
    after(valueA, valueB) {
        return { after: [dateStringFromValue(valueA), dateStringFromValue(valueB)] };
    },
    before(valueA, valueB) {
        return { before: [dateStringFromValue(valueA), dateStringFromValue(valueB)] };
    },
    // String
    // ------
    joinStrings(separator, strings) {
        return { joinStrings: { separator, strings } };
    },
    stringToLower(value) {
        return { stringToLower: value };
    },
    matchRegex(regex, value, caseInsensitive = false, multiLine = false) {
        return { matchRegex: { regex, value, caseInsensitive, multiLine } };
    },
    searchAllRegex(regex, value, caseInsensitive = false, multiLine = false) {
        return { searchAllRegex: { regex, value, caseInsensitive, multiLine } };
    },
    searchRegex(regex, value, caseInsensitive = false, multiLine = false) {
        return { searchRegex: { regex, value, caseInsensitive, multiLine } };
    },
    // Optional
    // --------
    isPresent(optional) {
        return { isPresent: optional };
    },
    // Set
    // ---
    mapSet(value, expression) {
        return { mapSet: { value, expression } };
    },
    // Map
    // ---
    setKey(name, value, inMap) {
        return { setKey: { name, value, in: inMap } };
    },
    mapMap(value, expression) {
        return { mapMap: { value, expression } };
    },
    key(name, value) {
        return { key: { name, value } };
    },
    // Union
    // -----
    isCase(caseKey, value) {
        return { isCase: { case: caseKey, value } };
    },
    // Tuple
    // -----
    index(index, value) {
        return { index: { number: index, value } };
    },
    // Struct
    // ------
    extractStrings(value) {
        return { extractStrings: value };
    },
    field(name, value) {
        return { field: { name, value } };
    },
    setField(name, value, inStruct) {
        return { setField: { name, value, in: inStruct } };
    },
    // List
    // ----
    concatLists(valueA, valueB) {
        return { concatLists: [valueA, valueB] };
    },
    filter(value, expression) {
        return { filter: { value, expression } };
    },
    first(value) {
        return { first: value };
    },
    inList(inList, value) {
        return { inList: { value, in: inList } };
    },
    mapList(value, expression) {
        return { mapList: { value, expression } };
    },
    length(value) {
        return { length: value };
    },
    memSort(value, expression) {
        return { memSort: { value, expression } };
    },
    reverseList(value) {
        return { reverseList: value };
    },
    slice(value, offset, length) {
        return { slice: { value, offset, length } };
    },
    reduceList(value, expression) {
        return { reduceList: { value, expression } };
    },
    // User / Permission
    // -----------------
    currentUser() {
        return { currentUser: {} };
    },
    // Graph / Referential
    // -------------------
    refTo(value) {
        return { refTo: value };
    },
    referred(from, inRef) {
        return { referred: { from, in: inRef } };
    },
    referrers(of, inRef) {
        return { referrers: { of, in: inRef } };
    },
    relocateRef(model, ref) {
        return { relocateRef: { model, ref } };
    },
    resolveAllRefs(ref) {
        return { resolveAllRefs: ref };
    },
    resolveRefs(value, models) {
        return { resolveRefs: { models, value } };
    },
    tag(value) {
        return { tag: value };
    },
    graphFlow(start, flow) {
        return { graphFlow: { start, flow } };
    },
    // CRUD
    // ----
    all(ref) {
        return { all: ref };
    },
    create(modelRef, value) {
        return { create: { in: modelRef, value } };
    },
    createMultiple(modelRef, values) {
        return { createMultiple: { in: modelRef, values } };
    },
    delete(ref) {
        return { delete: ref };
    },
    get(ref) {
        return { get: ref };
    },
    update(ref, value) {
        return { update: { ref, value } };
    },
    // Logic
    // -----
    and(...values) {
        return { and: values };
    },
    or(...values) {
        return { or: values };
    },
    assertCase(caseKey, value) {
        return { assertCase: { case: caseKey, value } };
    },
    assertModelRef(ref, value) {
        return { assertModelRef: { ref, value } };
    },
    assertPresent(value) {
        return { assertPresent: value };
    },
    equal(valueA, valueB) {
        return { equal: [valueA, valueB] };
    },
    if(condition, then, otherwise) {
        return { if: { condition, then, else: otherwise } };
    },
    not(value) {
        return { not: value };
    },
    presentOrZero(value) {
        return { presentOrZero: value };
    },
    switchCase(value, cases) {
        return { switchCase: { value, cases } };
    },
    switchModelRef(value, defaultValue, cases) {
        return { switchModelRef: { value, default: defaultValue, cases } };
    },
    // Numeric
    // -------
    add(valueA, valueB) {
        return { add: [valueA, valueB] };
    },
    subtract(valueA, valueB) {
        return { add: [valueA, valueB] };
    },
    multiply(valueA, valueB) {
        return { add: [valueA, valueB] };
    },
    divide(valueA, valueB) {
        return { add: [valueA, valueB] };
    },
    less(valueA, valueB) {
        return { add: [valueA, valueB] };
    },
    greater(valueA, valueB) {
        return { add: [valueA, valueB] };
    },
    floatToInt(value) {
        return { floatToInt: value };
    },
    intToFloat(value) {
        return { intToFloat: value };
    }
};
//# sourceMappingURL=expression.js.map